export default __webpack_public_path__ + "static/media/interface-11.6d7894bf.png";